module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAgCAMAAAAynjhNAAAAYFBMVEUAAAAPJFEPI1API1EOJ1IPJVAOJFEQI1ESI1EPJFEOJVEJJVcPI1ANIlENJk4OJFEPI1ETJlIAJlQOI1IOI1API1AQI1EQI1EPJFEPI1APJFAQI1IQIlMPJFEOI1IPJFEkrIeTAAAAIHRSTlMAU6mYGSLBXhy9oAhlJhNqkg0ERTS2TzzbhHhzL+Cfh40aduIAAAC4SURBVCjP7dFZEoMgEARQVp2ICyiKW5L73zLIR6ipwcoF0r9dj2KqGYrmdejZbfxuh9PctdDOz+roblpdy2pdRauLHmox27d4iKEr2qaSy8ntI3lqY6uMWmTy1Db8OkpxmTyxXDGWeuSRZcgTS/2IbfaduVpksXfMIesc8oHp6ZVt7wOM3362e6ytjJYuBnzbjvj4NEFxMfDBX38bi4ul5r/Yj8Vw6GI5dDEUuhhOXsw4AFesTa/UBwg4D+Iz5mkfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/backTop.png
// module id = twXS
// module chunks = 41